/** Are we running in dev? */
const url = typeof document !== 'undefined' ? document.location?.href : null

const ngrokDomain = 'directly-honest-donkey.ngrok-free.app'
// Check if the domain matches https://<sha>.preview.<domain>
const previewHost = url?.match(/^https:\/\/([^.]+\.preview\.[^\/]+)/)?.[1]
const isDev = Boolean(url?.startsWith('http://localhost'))
const isNgrok = Boolean(url?.startsWith(`https://${ngrokDomain}`))

const devOrigin = isDev && typeof document !== 'undefined' ? document.location.origin : null

/** @note - this is the aws-config object for CDK. We keep it here because other packages also depend on e.g., userPoolId config */
const config = {
  aws_project_region: 'eu-west-1',
  region: 'eu-west-1',
  bucketName: 'tunasong-storage',
  Auth: {
    userPoolId: 'eu-west-1_DQAVtgHXU',
    userPoolWebClientId: '4vviqhoonv2sbcf0lqmeufr7bb',
    oauth: {
      domain: 'auth.tunasong.com',
      scope: ['phone', 'email', 'profile', 'openid'],
      loginProxy: 'https://tunasong.com/api/auth/login-proxy',
      /**
       * W2 (docs/SECURITY.md): same-origin relative paths for the token-exchange
       * and refresh endpoints. Same-origin means the HttpOnly refresh cookie is
       * first-party in every environment — prod via CloudFront's `api/*`
       * behavior, dev via the vite `/api/auth` proxy, previews likewise — so
       * these deliberately carry no host (unlike the absolute Cognito redirect
       * URLs above, which Cognito requires).
       */
      loginWithCodeUrl: '/api/auth/login-with-code',
      refreshTokenUrl: '/api/auth/refresh-token',
      redirectSignIn: devOrigin
        ? `${devOrigin}/app/login`
        : previewHost
          ? `https://${previewHost}/app/login`
          : isNgrok
            ? `https://${ngrokDomain}/app/login`
            : 'https://tunasong.com/app/login',
      logoutProxy: 'https://tunasong.com/api/auth/logout-proxy',
      redirectSignOut: devOrigin
        ? `${devOrigin}/app/logout`
        : previewHost
          ? `https://${previewHost}/app/logout`
          : isNgrok
            ? `https://${ngrokDomain}/app/logout`
            : 'https://tunasong.com/app/logout',
      responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
  },
  /** Custom config */
  url: devOrigin ?? (isNgrok ? `https://${ngrokDomain}` : 'https://tunasong.com'),
}

export default config
